<template>
    <div>
        <el-drawer
            title="产品配置"
            :visible.sync="drawer"
            direction="rtl"
            size="60%"
            :before-close="handleClose">             
            <div class="product-config-content">
                <div class="customer-config-box">
                    <div class="customer-info">
                        <div class="customer-info-title">客户信息</div>
                        <el-descriptions class="margin-top" title="" :column="2" size="medium" border>                       
                            
                            <el-descriptions-item>
                                <template slot="label">
                                <span class="info-label">客户ID</span> 
                                </template>
                                {{customBathInfo.id}}
                            </el-descriptions-item>
                            
                            <el-descriptions-item>
                                <template slot="label">
                                <span class="info-label">客户昵称</span> 
                                </template>
                                {{customBathInfo.name}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                <span class="info-label">商户号</span> 
                                </template>
                                {{customBathInfo.api_key}}
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                <span class="info-label">客户邮箱</span> 
                                </template>
                                {{customBathInfo.username}}
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                    <div class="config-section">
                        <div class="config-section-title">
                            <span>卡密产品配置</span>                    
                            <el-button type="primary" icon="el-icon-plus" size="small" @click="addProductClick()">新增产品</el-button>
                        </div>
                        <div class="config-table">
                            <el-table border :data="configData.tableData">
                                <el-table-column prop="product_code" label="产品编码"></el-table-column>
                                <el-table-column prop="product_name" label="产品名称"></el-table-column>
                                <el-table-column prop="value" label="面值" ></el-table-column>
                                <el-table-column prop="" label="折扣比例" width="150px" >
                                    <template slot-scope="scope">
                                        <div>
                                            <el-input-number style="width: 120px;" 
                                            size="mini" 
                                            v-model="scope.row.discount" 
                                            :precision="3" :min="0" :step="0.001"></el-input-number>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="启用状态" width="100">
                                    <template slot-scope="scope">
                                        <div>
                                            <el-switch @change="changeConfig(scope.row)" v-model="scope.row.enabled_boolean" :disabled="configData.loading"></el-switch>
                                        </div>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="" label="操作" width="80">
                                    <template slot-scope="scope">
                                        <el-button type="text" class="cdanger delete-btn" @click="deleteProductConfig(scope.row)" :disabled="configData.loading"><i class="el-icon-delete"></i>删除</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </div>
                <div class="drawer-footer">
                    <div class="footer-btn">
                        <el-button size="small" @click="handleClose">取 消</el-button>
                        <el-button size="small" type="primary" @click="saveEditConfig" :loading="configData.loading" :disabled="configData.loading">保存配置</el-button>
                    </div>
                </div>
            </div>
        </el-drawer>
        <AddProductDialog v-if="configData.dialogVisible" :dialogVisible="configData.dialogVisible" :loading="configData.loading" @close="closeConfigChoose" @suerConfigChoose="suerConfigChoose" :traderId="customBathInfo.id"></AddProductDialog>
    </div>
</template>
<script>
    import AddProductDialog from '@/components/customerManage/addProductDialog.vue'


    export default {
        props:{
            drawer:{
                type: Boolean,
                default: false,
            },
            customBathInfo:{
                type: Object,
                default: function () {
                    return {}
                }
            },
            loading:{
                type: Boolean,
                default: false,

            }
        },
        data() {
            return {
                configData:{
                    productConfig:[],
                    dialogVisible:false,
                    tableData:[],
                    tableConfig:[],//数据完全复制tableData  用于比对下拉框数据是否可选
                    page:1,
                    pageSize: 100000,
                    loading:false,

                }
            }
        },
        components:{
            AddProductDialog
        },
        mounted() {
            this.memberProductConfig();
        },
        methods: {
             // 获取选项数据
             memberProductConfig(){
                let data = {
                    traderId:this.customBathInfo.id
                }
                this.$api.memberProductConfig(data).then(res=>{
                    if(res.status == 1){
                        res.data.configs.forEach(item=>{
                            item.enabled_boolean = item.enabled == 1? true:false
                            return item
                        })
                        this.configData.tableData = res.data.configs
                        // this.configData.tableConfig = JSON.parse(JSON.stringify(this.configData.tableData)) 
                    }
                })
            },
            handleClose(done) {
                this.$emit('closeDrawer')
            },
            //打开配置项选择弹窗
            addProductClick(){
                this.configData.dialogVisible = true;
            },
            //关闭配置项选择弹窗
            closeConfigChoose(){
                this.configData.dialogVisible = false;
            },
            suerConfigChoose(config){
                this.saveConfig(config,true)
            },
            //删除配置项
            deleteProductConfig(item){
                if(this.configData.tableData.length == 1){
                    this.$message({
                        message: '至少保留一个产品配置',
                        type: 'warning'
                    })
                    return;
                }
                this.$confirm('此操作将从数据库删除该客户的该产品配置, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let index = 0;
                    this.configData.tableData.forEach((config,i)=>{
                        if(item.product_code == config.product_code && item.value == config.value){
                            index = i
                        }
                    })
                    let data ={
                        traderId:this.customBathInfo.id,
                        product_code:item.product_code,
                        value:item.value,
                    }
                    this.configData.loading = true
                    this.$api.deleteConfig(data).then(res=>{
                        this.configData.loading = false
                        if(res.status == 1){
                            this.$message.success('删除成功')    
                            this.memberProductConfig()
                        }else{
                            this.$message.error('删除失败')

                        }
                    }).catch(e=>{
                        this.configData.loading = false
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });          
                })
               
            },
            //修改配置项开关
            changeConfig(row){
                let enabled_boolean = row.enabled_boolean 
                row.enabled_boolean = row.enabled == 1?true:false;
                let status = row.enabled == 1?0:1
                let data = {
                    traderId:this.customBathInfo.id,
                    product_code:row.product_code,
                    value:row.value,
                    enabled:status,
                }
                this.$api.enableConfig(data).then(res=>{
                    if(res.status == 1){                        
                        row.enabled_boolean = enabled_boolean
                        this.$message.success(res.msg)
                    }else{
                        this.$message.error(res.msg)
                    }
                })
            },
            //保存配置按钮事件
            saveEditConfig(){
                this.saveConfig(this.configData.tableData,false)
            },
            //保存配置 接口
            saveConfig(config,refreshTable){
                let denoms = []
                config.forEach(item=>{
                    denoms.push({
                        product_code:item.product_code,
                        value:item.value,
                        enabled: item.enabled_boolean == true ?1:0,
                        discount:item.discount,
                    })
                })
                let data = {
                    traderId: this.customBathInfo.id,
                    items:denoms,
                }
                this.configData.loading = true
                this.$api.saveConfig(data).then(res => {                    
                    this.closeConfigChoose();//关闭选项弹窗
                    this.configData.loading = false
                    if(res.status == 1){
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                        if(refreshTable){
                            this.memberProductConfig();
                        }else{
                            this.$emit('closeDrawer')
                        }
                        

                    }else{
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }                    
                }).catch(e=>{
                    this.configData.loading = false
                })
            },
            
        }
    }
</script>
<style lang="scss" scoped>
    .product-config-content{
        display: flex;
        justify-content: space-between;
        flex-direction: column;
        height: calc(100vh - 75px);
        padding: 20px;
        .customer-config-box{
            flex: 1;
            overflow: auto;
        }
        .customer-info{
            padding: 0 20px;
            margin-bottom: 24px;
            .customer-info-title{
                margin-bottom: 16px;
                color: #303133;
                font-size: 16px;
                font-weight: 600;
            }
            .info-label{
                color: #606266;
                font-weight: 700;
            }
        }       
        .config-section{
            padding: 0 20px;
            margin-bottom: 24px;
            .config-section-title{
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 16px;
                color: #303133;
                font-size: 16px;
                font-weight: 600;
            }
            .delete-btn{
                &:hover{
                    color:#fab6b6,
                }
                &:focus{
                    color:#fab6b6,
                }
            }
        }
        .drawer-footer{
            padding: 10px 20px 0;
            // padding-top: 10px;
            text-align: right;
            .footer-btn{
                display: flex;
                justify-content: flex-end;
                gap: 12px;
                padding: 16px 20px;
                border-top: 1px solid #ebeef5;
                background-color: #fafafa;
            }
        }
    }
</style>